// src/lib/tryout/presetOverrides.ts
/**
 * Merges the hardcoded PRESET_IMAGES defaults with admin-managed overrides from
 * the tryout_preset_overrides table. A NULL (or empty) override field means
 * "use the default". `room` is never overridden — staging semantics stay bound
 * to the preset id. Kept pure (no Supabase import) so it is unit-testable and
 * usable from both the public funnel and the admin view.
 */
import type { PresetImage } from '@/components/tryout/TryoutStep1Upload';

export interface PresetOverrideRow {
  preset_id: string;
  label: string | null;
  source_path: string | null;
  source_updated_at: string | null;
  room: string | null;
}

export function resolvePresets(
  defaults: PresetImage[],
  overrides: PresetOverrideRow[],
  toUrl: (path: string) => string,
): PresetImage[] {
  const byId = new Map(overrides.map((o) => [o.preset_id, o]));
  return defaults.map((d) => {
    const o = byId.get(d.id);
    if (!o) return d;
    return {
      ...d,
      label: o.label ? o.label : d.label,
      src: o.source_path ? toUrl(o.source_path) : d.src,
      room: o.room ? o.room : d.room,
    };
  });
}

export function sourceIsNewerThanBakes(
  sourceUpdatedAt: string | null,
  bakeUpdatedAts: string[],
): boolean {
  if (!sourceUpdatedAt) return false;
  const src = Date.parse(sourceUpdatedAt);
  return bakeUpdatedAts.some((b) => Date.parse(b) < src);
}
